import ControlSelect from "./Select";

export default ControlSelect;
